import { titleCase } from '@pushly/models/lib/utils/change-case'

/**
 * Journeys were formerly called campaigns, and the API still reports a journey-sent notification with the
 * source `campaign`. The label shown to users must say "Journey" wherever a notification source is displayed.
 */
export const NOTIFICATION_SOURCE_LABELS: Readonly<Record<string, string>> = {
    CAMPAIGN: 'Journey',
    FEED: 'Feed',
    MANUAL: 'Manual',
}

export const NOTIFICATION_SOURCE_OPTIONS: ReadonlyArray<{ value: string; label: string }> = Object.entries(
    NOTIFICATION_SOURCE_LABELS,
).map(([value, label]) => ({ value, label }))

export function notificationSourceLabel(source: string): string {
    return NOTIFICATION_SOURCE_LABELS[source.toUpperCase()] ?? titleCase(source)
}
